/**
 * --------------------------------------------------------------------------
 * NJ : Fab.js
 * --------------------------------------------------------------------------
 */

import { Data, EventHandler, Manipulator } from 'nj-utils';
import { coreConfig, eventsName } from 'nj-components/core.config';
import AbstractComponent from 'nj-components/AbstractComponent';


/**
 * ------------------------------------------------------------------------
 * Constants
 * ------------------------------------------------------------------------
 */

const NAME      = `${coreConfig.KEY_PREFIX}-fab-menu`;
const DATA_KEY  = `${coreConfig.KEY_PREFIX}.fab`;
const EVENT_KEY = `.${DATA_KEY}`;
const CLASS_NAME = `.${NAME}`;

const EVENT = {
  click      : `${eventsName.click}${EVENT_KEY}`,
  mouseenter : `${eventsName.mouseenter}${EVENT_KEY}`,
  mouseleave : `${eventsName.mouseleave}${EVENT_KEY}`
};

const STAGGER_DELAY = 70;
const DURATION_PER_ITEM = 35;
const ITEMS_HEIGHT = 3.8;


/**
 * ------------------------------------------------------------------------
 * Class Definition
 * ------------------------------------------------------------------------
 */

class Fab extends AbstractComponent {
  constructor(element, config) {
    super(Fab, element);

    this.setConfig(config);
    this.element = element;

    this.setListeners();
    Data.setData(element, DATA_KEY, this);
  }

  open() {
    let i;
    const FAB_ITEMS = this.element.getElementsByClassName('nj-fab__item');
    const openClass = 'active';
    const menuPos = this.config.menuPosition;
    const durationMax = DURATION_PER_ITEM * FAB_ITEMS.length;
    const buttons = this.element.getElementsByClassName('nj-fab');
    const button = buttons[0];
    Manipulator.toggleClass(button, openClass);
    const open = button.classList.contains(openClass);
    for (i = 0; i < FAB_ITEMS.length; i++) {
      const transPos = menuPos === 'top' || menuPos === 'bottom' ? 'translateY' : 'translateX';
      const transWay = menuPos === 'top' || menuPos === 'left' ? '-' : '';
      const transLength = (i + 1) * ITEMS_HEIGHT + 1;
      const openAnimation = [
        {
          transform: `${transPos}(0)`,
          opacity: 0
        },
        {
          transform: `${transPos}(${transWay}${transLength}rem)`,
          opacity: 1
        }
      ];
      const keyFrames = open ? openAnimation : openAnimation.reverse();
      const duration = durationMax - DURATION_PER_ITEM * i;
      const delay = STAGGER_DELAY * i;
      FAB_ITEMS[i].animate(keyFrames, {
        duration,
        delay,
        fill: 'forwards'
      });
    }
  }

  setListeners() {
    const eventOpen = EVENT.click;

    EventHandler.on(this.element,
      eventOpen,
      this.config.selector,
      () => this.open()
    );
  }

  setConfig(config) {
    const menuPosition = this.element.getAttribute('data-placement');
    this.config = {
      menuPosition
    };
    this.config = Object.assign(this.config, config);

    // Avoid wrong configuration
    if (['top', 'right', 'bottom', 'left'].indexOf(this.config.menuPosition) < 0) {
      this.config.menuPosition = 'top';
    }
  }

  getConfig() {
    return this.config;
  }

  dispose() {
    Data.removeData(this.element, DATA_KEY);
    this.element = null;
  }

  static getInstance(element) {
    return Data.getData(element, DATA_KEY);
  }

  static init(options) {
    return super.init(this, options, CLASS_NAME);
  }

  static selector = CLASS_NAME;
}

export default Fab;
